import React from 'react';
import PropTypes from 'prop-types';
import ClampLines from 'react-clamp-lines';
import styles from './index.scss';
import { useFeedEntityContext } from '../FeedEntityContext';
import useFeedAnalytics from '../../../hooks/useFeedAnalytics';
import useFeedIntersectionObserver from '../../../hooks/useFeedIntersectionObserver';

// This is for Maharaj achievements only - https://github.com/strava/maharaj
const AchievementCelebration = ({
  url,
  text,
  subtitle,
  image,
  type,
  analytics,
  activityOwnerId,
  image_caption: imageCaption
}) => {
  const { analyticProps } = useFeedEntityContext() || {};

  const { inView, intersectionObserverRef } = useFeedIntersectionObserver({
    isParentFeedEntry: false
  });

  const getElementType = (achievementType) => {
    switch (achievementType) {
      case 'challenge':
        return 'challenge_completion';
      default:
        return achievementType;
    }
  };

  useFeedAnalytics({
    ...analyticProps,
    element: getElementType(type),
    properties: {
      activity_athlete_id: activityOwnerId,
      ...analytics
    },
    inView
  });

  return (
    <div
      className={styles.achievementCelebration}
      data-testid="celebration_container"
      ref={intersectionObserverRef}
    >
      <div className={styles.celebrationBadge}>
        <img
          data-testid="celebration_badge"
          src={image}
          title={imageCaption}
          alt={imageCaption}
        />
      </div>
      <div className={styles.celebrationText}>
        <div className={styles.celebrationTitle}>
          <a data-testid="celebration_title" href={url} aria-label={text}>
            <ClampLines
              text={text}
              id="default"
              lines={2}
              buttons={false}
              delay={100}
            />
          </a>
        </div>
        {subtitle && (
          <div
            data-testid="celebration_subtitle"
            className={`text-caption1 ${styles.celebrationSubtitle}`}
          >
            <ClampLines
              text={subtitle}
              id="default"
              lines={2}
              buttons={false}
              delay={100}
            />
          </div>
        )}
      </div>
    </div>
  );
};

AchievementCelebration.propTypes = {
  url: PropTypes.string,
  text: PropTypes.string,
  subtitle: PropTypes.string,
  image: PropTypes.string,
  image_caption: PropTypes.string,
  type: PropTypes.string,
  activityOwnerId: PropTypes.string,
  analytics: PropTypes.shape({})
};

AchievementCelebration.defaultProps = {
  url: '',
  text: '',
  subtitle: null,
  image: '',
  image_caption: '',
  type: '',
  analytics: {},
  activityOwnerId: ''
};

export default AchievementCelebration;
